<template>
  <el-dialog
    title="订单全部退款"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form
      ref="refundForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
      v-loading="loading"
    >
      <el-form-item label="退款计划">
        <el-input v-model="planInfo.plan_title" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="距离出发">
        <el-input :value="planInfo.near_day + '天'" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="订单金额">
        <el-input v-model="planInfo.order_amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="当前金额">
        <el-input v-model="planInfo.curr_amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="手续费率">
        <el-input v-model="planInfo.fee_rate" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="手续费金额">
        <el-input v-model="planInfo.fee_amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="退款金额">
        <el-input v-model="planInfo.refund_amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="退款类型" prop="back_type">
        <el-radio-group v-model="formData.back_type">
          <el-radio :label="0">全额退款</el-radio>
          <el-radio :label="1">部分退款</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="处理类型" prop="type">
        <el-radio-group v-model="formData.type">
          <el-radio :label="1">正常处理</el-radio>
          <el-radio :label="2">特殊处理</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="退款备注" prop="back_note">
        <el-input
          type="textarea"
          v-model="formData.back_note"
          :rows="3"
          placeholder="请输入退款备注"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderRefundDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      planInfo: {
        plan_title: '',
        near_day: 0,
        order_amount: '',
        curr_amount: '',
        fee_rate: '',
        fee_amount: '',
        refund_amount: ''
      },
      formData: {
        back_type: 0,
        type: 1,
        back_note: ''
      },
      rules: {
        back_type: [
          { required: true, message: '请选择退款类型', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择处理类型', trigger: 'change' }
        ],
        back_note: [
          { required: true, message: '请输入退款备注', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.orderId) {
        this.loadFormData()
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    async loadFormData() {
      if (!this.orderId) return
      
      this.loading = true
      try {
        const response = await axios.get(`${this.base_url}/orders/${this.orderId}/refund/form`)
        if (response.status === 200 && response.data.code) {
          const data = response.data.data
          this.planInfo = {
            plan_title: data.plan_title || '',
            near_day: data.near_day || 0,
            order_amount: data.order_amount || '',
            curr_amount: data.curr_amount || '',
            fee_rate: data.fee_rate || '',
            fee_amount: data.fee_amount || '',
            refund_amount: data.refund_amount || ''
          }
        } else {
          this.$message.error(response.data.message || '获取表单数据失败')
        }
      } catch (error) {
        console.error('获取表单数据失败:', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.$refs.refundForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const response = await axios.post(`${this.base_url}/orders/${this.orderId}/refund/submit`, this.formData)
            if (response.status === 200 && response.data.code) {
              this.$message.success('订单退款处理成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(response.data.message || '退款处理失败')
            }
          } catch (error) {
            console.error('退款处理失败:', error)
            this.$message.error('退款处理失败')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.refundForm && this.$refs.refundForm.resetFields()
      this.formData = {
        back_type: 0,
        type: 1,
        back_note: ''
      }
      this.planInfo = {
        plan_title: '',
        near_day: 0,
        order_amount: '',
        curr_amount: '',
        fee_rate: '',
        fee_amount: '',
        refund_amount: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}
</style>